var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 297,
    height: 297,
    viewBox: "0 0 297 297",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 148.5,
    cy: 148.5,
    r: 148.5,
    fill: "url(#paint0_linear_812_11335)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.321 152.257C111.737 149.8 121.726 155.5 131.656 165.024C141.601 174.54 147.729 184.283 145.375 186.795L145.36 186.804L127.545 197.049C120 193.581 106.611 186.331 97.4628 175.109L109.321 152.257ZM130.752 165.978C122.42 157.993 114.142 153.117 112.237 155.048L111.873 155.782C111.375 158.567 116.372 165.859 123.926 173.094C131.479 180.329 138.987 185.011 141.742 184.392L142.459 184.003C144.314 182.019 139.084 173.964 130.752 165.978Z",
    fill: "#4C7BA8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.472 199.216L91.3551 218.836C87.4891 212.641 85.0926 205.859 83.6056 199.955L95.3891 177.275C104.541 188.486 117.927 195.748 125.472 199.216Z",
    fill: "url(#paint1_linear_812_11335)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8195 235.54L81.0999 202.271C82.5869 208.174 84.9834 214.956 88.8494 221.152L63.8195 235.54Z",
    fill: "#061D33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.611 91.2087C126.515 86.7182 128.816 83.3937 130.749 83.7833C132.682 84.1728 133.516 88.1288 132.611 92.6193C131.706 97.1097 129.406 100.434 127.472 100.045C125.539 99.6552 124.706 95.6992 125.611 91.2087Z",
    fill: "#F97C00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M201.752 150.707C198.769 149.856 196.846 147.431 197.457 145.291C198.067 143.152 200.98 142.107 203.963 142.958C206.945 143.809 208.868 146.234 208.258 148.374C207.647 150.513 204.734 151.558 201.752 150.707Z",
    fill: "#F97C00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M194.613 129.014C193.014 128.231 195.258 120.369 199.624 111.452C203.991 102.536 208.827 95.9429 210.425 96.7259C212.024 97.5088 209.781 105.372 205.414 114.288C201.047 123.204 196.212 129.797 194.613 129.014Z",
    fill: "#F97C00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M186.843 83.589C184.709 82.9803 183.676 80.0476 184.535 77.0387C185.393 74.0297 187.819 72.084 189.952 72.6927C192.085 73.3014 193.118 76.2341 192.26 79.2431C191.401 82.252 188.976 84.1978 186.843 83.589Z",
    fill: "#F97C00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M128.985 112.939L128.462 114.453L129.41 115.741L127.811 115.698L126.871 117.002L126.419 115.468L124.895 114.982L126.201 114.065L126.193 112.464L127.476 113.436L128.985 112.939Z",
    fill: "url(#paint2_linear_812_11335)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M156.162 115.331L157.09 115.016L156.773 115.944L157.346 116.739L156.372 116.719L155.795 117.521L155.51 116.576L154.575 116.283L155.382 115.714L155.378 114.733L156.162 115.331Z",
    fill: "url(#paint3_linear_812_11335)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M149.423 91.6459L150.363 91.3339L150.035 92.2587L150.619 93.0572L149.633 93.0337L149.068 93.8394L148.783 92.8943L147.848 92.6017L148.655 92.0327L148.652 91.0518L149.423 91.6459Z",
    fill: "url(#paint4_linear_812_11335)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M185.859 141.016L185.574 140.071L184.643 139.767L185.446 139.209L185.443 138.229L186.214 138.823L187.154 138.511L186.826 139.435L187.41 140.234L186.424 140.21L185.859 141.016Z",
    fill: "url(#paint5_linear_812_11335)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M163.554 137.18L163.266 136.246L162.334 135.942L163.138 135.385L163.134 134.404L163.921 134.989L164.845 134.686L164.529 135.614L165.113 136.413L164.127 136.389L163.554 137.18Z",
    fill: "url(#paint6_linear_812_11335)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M188.078 118.921L187.793 117.976L186.861 117.671L187.665 117.114L187.661 116.133L188.445 116.731L189.385 116.419L189.056 117.344L189.641 118.142L188.655 118.119L188.078 118.921Z",
    fill: "url(#paint7_linear_812_11335)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M150.706 135.537L150.14 136.342L149.856 135.397L148.912 135.089L149.728 134.536L149.724 133.555L150.496 134.149L151.435 133.837L151.107 134.762L151.692 135.56L150.706 135.537Z",
    fill: "url(#paint8_linear_812_11335)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M216.361 117.798L215.909 116.264L214.385 115.778L215.688 114.873L215.68 113.272L216.966 114.232L218.475 113.734L217.953 115.249L218.9 116.537L217.297 116.505L216.361 117.798Z",
    fill: "url(#paint9_linear_812_11335)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M161.058 81.3647L160.607 79.8305L159.082 79.344L160.388 78.4274L160.381 76.8267L161.664 77.7986L163.172 77.3008L162.653 78.803L163.6 80.0918L161.998 80.06L161.058 81.3647Z",
    fill: "url(#paint10_linear_812_11335)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M163.65 145.38L165.174 144.874L164.652 146.388L165.599 147.677L163.997 147.645L163.06 148.938L162.605 147.416L161.081 146.929L162.387 146.013L162.379 144.412L163.65 145.38Z",
    fill: "url(#paint11_linear_812_11335)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M179.927 162.439C180.371 161.019 179.129 159.362 177.163 158.75C179.129 159.362 181.094 158.711 181.538 157.291C181.094 158.711 182.336 160.368 184.301 160.98C182.324 160.364 180.371 161.019 179.927 162.439Z",
    fill: "url(#paint12_linear_812_11335)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M161.599 163.051L162.539 162.739L162.211 163.664L162.795 164.462L161.809 164.439L161.232 165.241L160.947 164.296L160.012 164.004L160.819 163.435L160.816 162.454L161.599 163.051Z",
    fill: "url(#paint13_linear_812_11335)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M146.917 169.238C157.152 171.231 167.951 174.996 174.577 183.539C177.044 186.821 179.009 191.005 178.971 195.248C178.327 200.892 169.736 199.962 170.332 194.304C170.328 194.316 170.326 194.367 170.335 194.383L170.35 194.374C170.988 190.379 169.094 186.397 166.758 183.152C161.763 176.621 154.373 172.475 146.917 169.238Z",
    fill: "url(#paint14_linear_812_11335)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M211.634 135.724C211.642 135.739 211.691 135.792 211.703 135.795L211.707 135.783C208.843 131.769 203.802 129.918 198.991 129.112C189.071 127.686 179.104 130.399 169.862 133.963C180.467 126.933 193.062 120.974 206.12 122.741C211.066 123.481 216.359 125.443 219.943 129.148C224.213 134.607 215.944 141.131 211.634 135.724Z",
    fill: "url(#paint15_linear_812_11335)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8792 113.818C99.8447 113.043 105.117 114.625 109.403 116.957C120.6 123.259 126.9 135.293 131.018 146.975C125.93 138.781 119.761 130.806 111.219 126.087C107.007 123.905 101.992 122.371 97.4046 123.808L97.4012 123.82C97.4131 123.823 97.4829 123.805 97.4948 123.808C90.9562 125.487 88.3627 115.555 94.8792 113.818Z",
    fill: "url(#paint16_linear_812_11335)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M163.823 104.342C163.326 101.428 162.212 98.3771 159.781 96.6392L159.769 96.6358L159.81 96.6733C156.521 94.0587 160.477 89.0508 163.788 91.633C166.03 93.8069 167.23 97.0114 167.675 100.013C168.744 107.925 165.131 115.571 160.888 121.992C163.052 116.395 164.687 110.351 163.823 104.342Z",
    fill: "url(#paint17_linear_812_11335)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M195.458 155.138C194.514 154.92 193.669 154.357 193.08 153.531L192.013 152.028C191.729 151.624 191.359 151.519 191.162 151.488C190.964 151.458 190.579 151.451 190.274 151.751L187.949 154.027C186.659 155.296 184.458 155.145 183.038 153.708C182.578 153.242 181.857 153.191 181.432 153.598L179.404 155.598C177.647 157.327 175.255 158.346 172.674 158.448C170.089 158.561 167.416 157.76 165.151 156.211L163.88 155.332C163.601 155.137 163.272 155.069 162.957 155.134C162.642 155.198 162.407 155.389 162.275 155.674C161.349 157.653 159.733 159.203 157.709 160.018C155.681 160.844 153.326 160.92 151.074 160.226C150.86 160.165 150.666 160.032 150.514 159.885C150.226 159.584 150.074 159.167 150.151 158.763C150.277 158.142 150.89 157.801 151.53 157.997C155.122 159.099 158.665 157.66 160.135 154.496C160.534 153.643 161.3 153.036 162.233 152.838C163.166 152.64 164.2 152.858 165.05 153.449L166.32 154.327C170.03 156.868 174.805 156.671 177.675 153.841L179.703 151.841C180.993 150.572 183.193 150.723 184.614 152.16C185.074 152.626 185.794 152.677 186.22 152.27L188.533 149.991C189.23 149.313 190.221 149.002 191.256 149.169C192.292 149.336 193.244 149.93 193.867 150.817L194.934 152.32C195.126 152.594 195.397 152.774 195.714 152.839C196.027 152.916 196.327 152.859 196.57 152.684C197.069 152.336 197.802 152.481 198.214 153.024C198.626 153.567 198.56 154.296 198.061 154.643C197.331 155.17 196.404 155.344 195.458 155.138Z",
    fill: "#ED1C24"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M142.156 107.221C141.943 106.748 142.157 106.177 142.637 105.94C143.117 105.703 143.691 105.906 143.904 106.379C144.221 107.075 144.24 107.867 143.951 108.61C143.665 109.34 143.098 109.926 142.378 110.237L141.05 110.825C140.696 110.981 140.563 111.266 140.519 111.421C140.475 111.576 140.413 111.881 140.619 112.197L142.11 114.518C142.511 115.148 142.645 115.895 142.482 116.648C142.319 117.401 141.868 118.033 141.228 118.469C140.797 118.759 140.67 119.341 140.939 119.753L142.264 121.794C143.409 123.565 143.904 125.717 143.671 127.843C143.423 129.977 142.457 132.008 140.931 133.559L140.075 134.436C139.891 134.628 139.793 134.884 139.796 135.143C139.811 135.405 139.924 135.643 140.135 135.807C141.59 136.944 142.607 138.575 142.992 140.387C143.39 142.202 143.145 144.143 142.313 145.84C142.075 146.313 141.496 146.535 141.031 146.312C140.927 146.269 140.842 146.206 140.764 146.119C140.493 145.849 140.411 145.413 140.595 145.04C141.927 142.313 141.247 139.141 138.915 137.328C138.293 136.841 137.911 136.1 137.872 135.29C137.829 134.491 138.135 133.689 138.714 133.106L139.57 132.229C142.061 129.691 142.504 125.743 140.635 122.851L139.309 120.809C138.909 120.179 138.774 119.432 138.937 118.679C139.101 117.926 139.552 117.295 140.192 116.858C140.623 116.569 140.75 115.986 140.481 115.574L138.97 113.235C138.511 112.537 138.411 111.67 138.669 110.854C138.928 110.039 139.527 109.384 140.308 109.04L141.633 108.464C141.868 108.364 142.052 108.171 142.147 107.928C142.26 107.715 142.256 107.456 142.156 107.221Z",
    fill: "#ED1C24"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M165.817 129.482C165.697 129.357 165.585 129.209 165.503 129.044C165.183 128.36 165.441 127.634 166.083 127.418C169.71 126.183 171.562 122.496 170.612 118.46C170.356 117.369 170.56 116.293 171.173 115.5C171.786 114.708 172.751 114.262 173.843 114.277L175.457 114.312C180.135 114.409 183.829 111.132 184.216 106.523L184.489 103.262C184.567 102.266 185.055 101.413 185.84 100.876C186.625 100.339 187.614 100.17 188.641 100.412C188.979 100.495 189.306 100.434 189.561 100.262C189.816 100.09 189.973 99.812 190.002 99.4851L190.314 95.7709C190.411 94.664 191.001 93.7238 191.932 93.216C192.864 92.7082 194.032 92.6806 195.139 93.1383L197.018 93.9193C197.353 94.0537 197.699 94.0621 197.995 93.9275C198.291 93.7929 198.492 93.5408 198.569 93.2274C198.732 92.5649 199.42 92.2326 200.118 92.4963C200.816 92.76 201.246 93.5143 201.095 94.1802C200.867 95.1594 200.233 95.9328 199.333 96.3333C198.432 96.7338 197.364 96.7256 196.353 96.2951L194.474 95.5141C193.978 95.3082 193.604 95.4462 193.423 95.5366C193.239 95.6388 192.94 95.8756 192.891 96.3644L192.578 100.079C192.5 101.075 192.012 101.928 191.227 102.465C190.442 103.001 189.453 103.17 188.426 102.929C188.089 102.846 187.762 102.907 187.506 103.079C187.251 103.251 187.094 103.529 187.066 103.856L186.793 107.117C186.555 109.937 185.332 112.463 183.329 114.238C181.339 116.017 178.661 116.954 175.802 116.899L174.187 116.864C173.83 116.852 173.518 116.995 173.314 117.259C173.11 117.523 173.05 117.867 173.129 118.225C173.722 120.753 173.473 123.299 172.407 125.406C171.342 127.513 169.508 129.104 167.251 129.878C166.764 130.048 166.195 129.873 165.817 129.482Z",
    fill: "#ED1C24"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M175.03 148.292C173.991 149.311 172.331 149.301 171.312 148.262C170.293 147.224 170.303 145.564 171.341 144.545C172.38 143.526 174.04 143.536 175.059 144.574C176.078 145.613 176.068 147.273 175.03 148.292Z",
    fill: "url(#paint18_linear_812_11335)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M215.373 171.098C214.334 172.117 212.674 172.107 211.655 171.069C210.637 170.03 210.646 168.37 211.685 167.351C212.723 166.332 214.383 166.342 215.402 167.381C216.421 168.419 216.399 170.076 215.373 171.098Z",
    fill: "url(#paint19_linear_812_11335)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M135.317 127.483C134.278 128.502 132.618 128.492 131.599 127.454C130.58 126.415 130.59 124.755 131.629 123.736C132.667 122.718 134.327 122.727 135.346 123.766C136.365 124.804 136.355 126.465 135.317 127.483Z",
    fill: "url(#paint20_linear_812_11335)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M152.112 108.566C151.073 109.585 149.413 109.575 148.394 108.537C147.375 107.498 147.385 105.838 148.423 104.819C149.462 103.801 151.122 103.81 152.141 104.849C153.163 105.875 153.15 107.548 152.112 108.566Z",
    fill: "url(#paint21_linear_812_11335)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M171.913 166.022C171.879 164.571 173.029 163.367 174.48 163.334C175.931 163.301 177.134 164.45 177.168 165.901C177.201 167.352 176.052 168.555 174.601 168.589C173.15 168.622 171.946 167.473 171.913 166.022Z",
    fill: "url(#paint22_linear_812_11335)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M103.031 80.969C103.097 79.519 104.326 78.3971 105.776 78.4633C107.226 78.5294 108.348 79.7585 108.282 81.2085C108.216 82.6585 106.987 83.7804 105.537 83.7142C104.087 83.6481 102.965 82.419 103.031 80.969Z",
    fill: "url(#paint23_linear_812_11335)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M141.573 158.495C141.601 157.043 142.8 155.89 144.251 155.918C145.702 155.946 146.856 157.145 146.828 158.596C146.8 160.047 145.601 161.201 144.15 161.173C142.698 161.145 141.545 159.946 141.573 158.495Z",
    fill: "url(#paint24_linear_812_11335)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M153.319 64.2823C153.29 62.8311 154.443 61.6311 155.894 61.602C157.345 61.5729 158.545 62.7258 158.574 64.177C158.603 65.6282 157.451 66.8283 155.999 66.8573C154.548 66.8864 153.348 65.7335 153.319 64.2823Z",
    fill: "url(#paint25_linear_812_11335)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M155.522 145.497C154.483 146.516 152.823 146.506 151.804 145.468C150.786 144.429 150.795 142.769 151.834 141.75C152.872 140.731 154.532 140.741 155.551 141.779C156.57 142.818 156.56 144.478 155.522 145.497Z",
    fill: "url(#paint26_linear_812_11335)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M218.72 91.4137C217.465 90.6839 217.04 89.0751 217.769 87.8203C218.499 86.5656 220.108 86.1401 221.363 86.8699C222.618 87.5998 223.043 89.2086 222.313 90.4633C221.583 91.718 219.975 92.1436 218.72 91.4137Z",
    fill: "url(#paint27_linear_812_11335)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M148.783 124.354C148.755 122.903 149.909 121.704 151.36 121.675C152.811 121.647 154.011 122.801 154.039 124.252C154.067 125.703 152.913 126.903 151.462 126.931C150.011 126.959 148.812 125.805 148.783 124.354Z",
    fill: "url(#paint28_linear_812_11335)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M171.794 102.387C170.776 101.349 170.785 99.6887 171.824 98.67C172.862 97.6513 174.523 97.661 175.541 98.6994C176.56 99.7379 176.55 101.398 175.512 102.417C174.485 103.439 172.813 103.426 171.794 102.387Z",
    fill: "url(#paint29_linear_812_11335)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_812_11335",
    x1: 201.5,
    y1: -147,
    x2: 114,
    y2: 297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3DAF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5EAF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_812_11335",
    x1: 93.1433,
    y1: 216.39,
    x2: 105.599,
    y2: 180.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C7BA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_812_11335",
    x1: 130.027,
    y1: 113.304,
    x2: 125.227,
    y2: 117.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E52B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#509036"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_812_11335",
    x1: 157.726,
    y1: 115.239,
    x2: 154.768,
    y2: 117.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E52B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#509036"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_812_11335",
    x1: 150.999,
    y1: 91.5573,
    x2: 148.042,
    y2: 93.8796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E52B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#509036"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_812_11335",
    x1: 187.79,
    y1: 138.734,
    x2: 184.833,
    y2: 141.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E52B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#509036"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_812_11335",
    x1: 165.493,
    y1: 134.913,
    x2: 162.55,
    y2: 137.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E52B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#509036"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_812_11335",
    x1: 190.021,
    y1: 116.642,
    x2: 187.063,
    y2: 118.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E52B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#509036"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_812_11335",
    x1: 152.071,
    y1: 134.06,
    x2: 149.114,
    y2: 136.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E52B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#509036"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_812_11335",
    x1: 219.517,
    y1: 114.1,
    x2: 214.717,
    y2: 117.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E52B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#509036"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_812_11335",
    x1: 164.214,
    y1: 77.6662,
    x2: 159.414,
    y2: 81.4531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E52B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#509036"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_812_11335",
    x1: 166.216,
    y1: 145.239,
    x2: 161.416,
    y2: 149.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E52B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#509036"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_812_11335",
    x1: 184.926,
    y1: 158.339,
    x2: 179.386,
    y2: 164.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E52B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#509036"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_812_11335",
    x1: 163.175,
    y1: 162.963,
    x2: 160.218,
    y2: 165.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E52B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#509036"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_812_11335",
    x1: 164.685,
    y1: 176.147,
    x2: 160.429,
    y2: 192.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0473EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#2F93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#2B8BF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0473EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_812_11335",
    x1: 198.608,
    y1: 122.437,
    x2: 194.371,
    y2: 138.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0473EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#2F93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#2B8BF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0473EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_812_11335",
    x1: 114.548,
    y1: 120.049,
    x2: 109.832,
    y2: 137.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0473EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#2F93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#2B8BF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0473EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_812_11335",
    x1: 164.733,
    y1: 94.6757,
    x2: 160.483,
    y2: 117.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0473EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#2F93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#2B8BF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0473EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_812_11335",
    x1: 172.762,
    y1: 148.583,
    x2: 173.522,
    y2: 143.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C31E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41602F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_812_11335",
    x1: 213.103,
    y1: 171.388,
    x2: 213.862,
    y2: 166.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C31E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41602F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_812_11335",
    x1: 133.05,
    y1: 127.774,
    x2: 133.809,
    y2: 123.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C31E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41602F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_812_11335",
    x1: 149.845,
    y1: 108.857,
    x2: 150.604,
    y2: 104.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C31E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41602F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_812_11335",
    x1: 176.659,
    y1: 165.908,
    x2: 172.562,
    y2: 166.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0473EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#2F93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#2B8BF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0473EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_812_11335",
    x1: 103.455,
    y1: 81.1755,
    x2: 108.242,
    y2: 80.8221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C31E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41602F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_812_11335",
    x1: 142.002,
    y1: 158.69,
    x2: 146.778,
    y2: 158.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C31E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41602F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_812_11335",
    x1: 153.756,
    y1: 64.4605,
    x2: 158.51,
    y2: 63.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C31E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41602F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_812_11335",
    x1: 153.255,
    y1: 145.788,
    x2: 154.014,
    y2: 141.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C31E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41602F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_812_11335",
    x1: 219.099,
    y1: 91.133,
    x2: 221.002,
    y2: 86.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C31E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41602F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_812_11335",
    x1: 149.22,
    y1: 124.533,
    x2: 153.974,
    y2: 123.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C31E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41602F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_812_11335",
    x1: 173.245,
    y1: 102.708,
    x2: 174.004,
    y2: 97.9627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C31E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41602F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessImg);
export default __webpack_public_path__ + "static/media/success-img.73c7caeea30f42e49bff1719bfd45727.svg";
export { ForwardRef as ReactComponent };